<div class="invalid-position-filter" [ngClass]="{ checked: hideInvalidPositions }">
  <div class="invalid-position-filter__title">
    <h3>{{ title() }}</h3>
  </div>
  <div class="invalid-position-filter__toggle">
    <mat-slide-toggle [checked]="hideInvalidPositions" (change)="toggle()"></mat-slide-toggle>
  </div>
</div>
